/**
 * 获取数据工具js
 */
import sessionStorageUtil from '@/api/sessionStorageUtil'
import { loginType } from '@/api/base'
const dataUtils = {
  getLoginUsername() {
    return sessionStorageUtil.get('agent_username')
      ? sessionStorageUtil.get('agent_username')
      : sessionStorageUtil.get('username')
  },
  getLoginName() {
    let type = loginType()
    switch (type) {
      case 0:
        return sessionStorageUtil.get('customer_service_name')
          ? sessionStorageUtil.get('customer_service_name')
          : sessionStorageUtil.get('agent_username')
      case 1:
        return sessionStorageUtil.get('name')
      case 2:
        return sessionStorageUtil.get('name')
      default:
        return sessionStorageUtil.get('name')
    }
  }
}
export default dataUtils



// WEBPACK FOOTER //
// ./src/api/utils/dataUtils.js